import { useLanguage } from '../../hooks/useLanguage';
import AppDownloadLinks from '../AppDownloadLinks/AppDownloadLinks';
import Modal from '../Modal/Modal';

type Props = {
  isOpen: boolean;
  closeModal: () => void;
};

export const AppReminder = (props: Props) => {
  const { closeModal, isOpen } = props;

  const { language } = useLanguage();

  return (
    <Modal
      open={isOpen}
      onClose={() => closeModal()}
      className="app-reminder"
      contentClassName="app-reminder-content"
      titleUnderline={false}
      actionsTopBorderline={true}
    >
      <div className="app-reminder">
        {/* Background image */}
        <div className="app-promotion-image">
          <img className="" src={`/images/app-promotion-${language}.jpg`} alt="app-reminder" />
        </div>

        {/* App download links */}
        <AppDownloadLinks />
      </div>
    </Modal>
  );
};
